import React, { useEffect, useRef, useState } from "react";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import Stack from "@mui/material/Stack";

interface ClampedTextProps {
  label: React.ReactNode;
  text: string;
  lines?: number;
}

export const ClampedText = ({ label, text, lines = 3 }: ClampedTextProps) => {
  const textRef = useRef<HTMLElement>(null);
  const [isClamped, setIsClamped] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [text]);

  return (
    <Stack spacing={1}>
      <IgTypography fontWeight={400}>{label}</IgTypography>
      <IgTypography
        ref={textRef}
        variant="body1"
        color="text.secondary"
        sx={
          expanded
            ? undefined
            : {
                display: "-webkit-box",
                WebkitLineClamp: lines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
        }
      >
        {text}
      </IgTypography>
      {(isClamped || expanded) && (
        <IgLink
          component="button"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{ alignSelf: "flex-start" }}
        >
          {expanded ? "Show less" : "Read more"}
        </IgLink>
      )}
    </Stack>
  );
};
